import { Button } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import { FlexBox } from '../../pages/shared-components/flex-box';
import './StepNav.scss';

interface StepNavProps {
  backText: string;
  forwardText: string;
  isExitDisplayed: boolean;
  exitText: string;
  onBack: () => void;
  onForward: () => void;
  onExit: () => void;
  isLastStep: boolean;
  lastStepForwardText?: string;
  children?: ReactNode;
}

const StepNavImpl: React.FC<StepNavProps> = (props) => {
  const {
    backText,
    forwardText,
    isExitDisplayed,
    exitText,
    onBack,
    onForward,
    onExit,
    isLastStep,
    lastStepForwardText,
    children,
  } = props;

  const forwardLabel = isLastStep ? (lastStepForwardText ?? forwardText) : forwardText;

  return (
    <FlexBox
      className='wizard-nav'
      isFullWidth
      aligns='start'
    >
      <FlexBox
        className='wizard-nav__controllers'
        isFullWidth
      >
        <FlexBox
          className='controllers__page'
          aligns='start'
        >
          {children}
        </FlexBox>
        <FlexBox
          wrap
          className='controllers__wizard'
          isFullWidth
          content='end'
          aligns='start'
        >
          <Button
            appearance='secondary'
            onClick={onBack}
          >
            {backText}
          </Button>
          {
            isExitDisplayed &&
            <Button
              appearance='secondary'
              onClick={onExit}
            >
              {exitText}
            </Button>
          }
          <Button
            appearance='primary'
            onClick={onForward}
          >
            {forwardLabel}
          </Button>
        </FlexBox>
      </FlexBox>
    </FlexBox>
  );
};

export const StepNav = observer(StepNavImpl);
